import type { ActiveReservationCoupon } from '../../../types/reservation-checkout'

export function getAppliedCouponTranslation(
    coupon: ActiveReservationCoupon,
): { key: string, values: { code: string, discount?: number } } {
    if (coupon.discount_percentage !== null) {
        return {
            key: 'checkout.discountCode.appliedPercentage',
            values: {
                code: coupon.code,
                discount: coupon.discount_percentage,
            },
        }
    }

    if (coupon.discount_amount_cents !== null) {
        return {
            key: 'checkout.discountCode.appliedAmount',
            values: {
                code: coupon.code,
                discount: Number((coupon.discount_amount_cents / 100).toFixed(2)),
            },
        }
    }

    return {
        key: 'checkout.discountCode.applied',
        values: {
            code: coupon.code,
        },
    }
}
